import { Container } from "react-bootstrap";
import "./GetStart.css";
import { Link } from "react-router-dom";

const GetStart = () => {
  return (
    <div className="start">
      <Container>
        <div className="holder">
          <div className="text-center ">
            <h1 className="text-capitalize">get started with homzy</h1>
            <p>
              Subscribe and find super attractive price quotes from us.
              <br />
              Find your residence soon
            </p>
            <a
              className="btn btn-primary text-capitalize"
              href="mailto:hossamahmed8862@gmail.com"
            >
              contact
            </a>
          </div>
        </div>
        <footer>
          <div className="row align-items-center m-3 justify-content-between text-center text-md-start">
            <div className="col-md-4">
              <Link to="/Homzy-Real-Estate">
                <img src={require("../../imgs/logo2.png")} alt="" />
              </Link>
              <p className="text-black-50">
                Our vision is to make all people
                <br />
                the best place to live for them.
              </p>
            </div>
            <div className="col-md-4">
              <h1 className="information">information</h1>
              <p className="text-black-50">145 New York, FL 5467, USA</p>
              <ul className="text-capitalize row p-0 fw-semibold">
                <li className="col">proprty</li>
                <li className="col">service</li>
                <li className="col">producT</li>
                <li className="col">about us</li>
              </ul>
            </div>
          </div>
        </footer>
      </Container>
    </div>
  );
};

export default GetStart;
